export const setupAnchorLinks = () => {
  const anchorLinks = document.querySelectorAll(
    'a[href^="#"]:not([href="#"])',
  ) as NodeListOf<HTMLAnchorElement>;

  anchorLinks.forEach((anchorLink) => {
    anchorLink.addEventListener("click", (event) => {
      event.preventDefault();
      if (
        location.pathname.replace(/^\//, "") ==
          anchorLink.pathname.replace(/^\//, "") &&
        location.hostname == anchorLink.hostname
      ) {
        const hash = anchorLink.hash;
        const target = hash.length
          ? (document.querySelector(`[id="${hash.slice(1)}"]`) as HTMLElement)
          : null;

        if (target) {
          window.scrollTo({
            top: (target as HTMLElement).offsetTop + 30,
            behavior: "smooth",
          });
        }
      }
      const target = anchorLink.href.split("#")[1];
      const targetElement = document.getElementById(target);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    });
  });
};
